import {
  getPaymentList,
  getPaymentWaitingList,
  getPaymentCompleteList,
  getInvoiceDetail,
  downloadInvoice,
  createPayment,
  getPaymentListFilter,
  getPartialPaymentList,
  getPaymentHistory,
  putProofPaymnet,
  getPaymentDetail,
  downloadProof
} from '@/api/payment.api'

import { PAYMENT_PAY_NOW } from '@/constant/localStorage'

export const FETCH_PAYMENT_LIST = 'FETCH_PAYMENT_LIST'
export const FETCH_PAYMENT_LIST_LOADING = 'FETCH_PAYMENT_LIST_LOADING'
export const FETCH_PAYMENT_LIST_DONE = 'FETCH_PAYMENT_LIST_DONE'
export const FETCH_PAYMENT_LIST_ERROR = 'FETCH_PAYMENT_LIST_ERROR'

export const FETCH_PAYMENT_WAITING = 'FETCH_PAYMENT_WAITING'
export const FETCH_PAYMENT_WAITING_LOADING = 'FETCH_PAYMENT_WAITING_LOADING'
export const FETCH_PAYMENT_WAITING_DONE = 'FETCH_PAYMENT_WAITING_DONE'
export const FETCH_PAYMENT_WAITING_ERROR = 'FETCH_PAYMENT_WAITING_ERROR'

export const FETCH_PAYMENT_PARTIAL = 'FETCH_PAYMENT_PARTIAL'
export const FETCH_PAYMENT_PARTIAL_LOADING = 'FETCH_PAYMENT_PARTIAL_LOADING'
export const FETCH_PAYMENT_PARTIAL_DONE = 'FETCH_PAYMENT_PARTIAL_DONE'
export const FETCH_PAYMENT_PARTIAL_ERROR = 'FETCH_PAYMENT_PARTIAL_ERROR'

export const FETCH_PAYMENT_COMPLETE = 'FETCH_PAYMENT_COMPLETE'
export const FETCH_PAYMENT_COMPLETE_LOADING = 'FETCH_PAYMENT_COMPLETE_LOADING'
export const FETCH_PAYMENT_COMPLETE_DONE = 'FETCH_PAYMENT_COMPLETE_DONE'
export const FETCH_PAYMENT_COMPLETE_ERROR = 'FETCH_PAYMENT_COMPLETE_ERROR'

export const FETCH_INVOICE_DETAIL = 'FETCH_INVOICE_DETAIL'
export const FETCH_INVOICE_DETAIL_LOADING = 'FETCH_INVOICE_DETAIL_LOADING'
export const FETCH_INVOICE_DETAIL_DONE = 'FETCH_INVOICE_DETAIL_DONE'
export const FETCH_INVOICE_DETAIL_ERROR = 'FETCH_INVOICE_DETAIL_ERROR'

export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE'
export const DOWNLOAD_INVOICE_LOADING = 'DOWNLOAD_INVOICE_LOADING'
export const DOWNLOAD_INVOICE_DONE = 'DOWNLOAD_INVOICE_DONE'
export const DOWNLOAD_INVOICE_ERROR = 'DOWNLOAD_INVOICE_ERROR'

export const DOWNLOAD_PROOF = 'DOWNLOAD_PROOF'
export const DOWNLOAD_PROOF_LOADING = 'DOWNLOAD_PROOF_LOADING'
export const DOWNLOAD_PROOF_DONE = 'DOWNLOAD_PROOF_DONE'
export const DOWNLOAD_PROOF_ERROR = 'DOWNLOAD_PROOF_ERROR'

export const CREATE_PAYMENT = 'CREATE_PAYMENT'
export const CREATE_PAYMENT_LOADING = 'CREATE_PAYMENT_LOADING'
export const CREATE_PAYMENT_DONE = 'CREATE_PAYMENT_DONE'
export const CREATE_PAYMENT_ERROR = 'CREATE_PAYMENT_ERROR'

export const PAYMENT_PROCESS_TEMP = 'PAYMENT_PROCESS_TEMP'

export const FETCH_PAYMENT_LIST_FILTER = 'FETCH_PAYMENT_LIST_FILTER'
export const FETCH_PAYMENT_LIST_FILTER_LOADING = 'FETCH_PAYMENT_LIST_FILTER_LOADING'
export const FETCH_PAYMENT_LIST_FILTER_DONE = 'FETCH_PAYMENT_LIST_FILTER_DONE'
export const FETCH_PAYMENT_LIST_FILTER_ERROR = 'FETCH_PAYMENT_LIST_FILTER_ERROR'

export const FETCH_PAYMENT_DETAIL = 'FETCH_PAYMENT_DETAIL'
export const FETCH_PAYMENT_DETAIL_LOADING = 'FETCH_PAYMENT_DETAIL_LOADING'
export const FETCH_PAYMENT_DETAIL_DONE = 'FETCH_PAYMENT_DETAIL_DONE'
export const FETCH_PAYMENT_DETAIL_ERROR = 'FETCH_PAYMENT_DETAIL_ERROR'

export const FETCH_PAYMENT_HISTORY = 'FETCH_PAYMENT_HISTORY'
export const FETCH_PAYMENT_HISTORY_LOADING = 'FETCH_PAYMENT_HISTORY_LOADING'
export const FETCH_PAYMENT_HISTORY_DONE = 'FETCH_PAYMENT_HISTORY_DONE'
export const FETCH_PAYMENT_HISTORY_ERROR = 'FETCH_PAYMENT_HISTORY_ERROR'

export const PUT_PAYMENT_PARTIAL_PROOF = 'PUT_PAYMENT_PARTIAL_PROOF'
export const PUT_PAYMENT_PARTIAL_PROOF_LOADING = 'PUT_PAYMENT_PARTIAL_PROOF_LOADING'
export const PUT_PAYMENT_PARTIAL_PROOF_DONE = 'PUT_PAYMENT_PARTIAL_PROOF_DONE'
export const PUT_PAYMENT_PARTIAL_PROOF_ERROR = 'PUT_PAYMENT_PARTIAL_PROOF_ERROR'

export default {
  [FETCH_PAYMENT_LIST] (context) {
    context.commit(FETCH_PAYMENT_LIST_LOADING)
    return getPaymentList()
      .then((response) => {
        context.commit(FETCH_PAYMENT_LIST_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PAYMENT_LIST_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_PAYMENT_PARTIAL] (context) {
    context.commit(FETCH_PAYMENT_PARTIAL_LOADING)
    return getPartialPaymentList()
      .then((response) => {
        context.commit(FETCH_PAYMENT_PARTIAL_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PAYMENT_PARTIAL_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_PAYMENT_LIST_FILTER] (context, type) {
    context.commit(FETCH_PAYMENT_LIST_FILTER_LOADING)
    return getPaymentListFilter(type)
      .then((response) => {
        context.commit(FETCH_PAYMENT_LIST_FILTER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PAYMENT_LIST_FILTER_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_PAYMENT_WAITING] (context) {
    context.commit(FETCH_PAYMENT_WAITING_LOADING)
    return getPaymentWaitingList()
      .then((response) => {
        context.commit(FETCH_PAYMENT_WAITING_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PAYMENT_WAITING_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_PAYMENT_COMPLETE] (context) {
    context.commit(FETCH_PAYMENT_COMPLETE_LOADING)
    return getPaymentCompleteList()
      .then((response) => {
        context.commit(FETCH_PAYMENT_COMPLETE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PAYMENT_COMPLETE_ERROR, true)
        console.error(error)
      })
  },

  [DOWNLOAD_INVOICE] (context, {idShipment, orderNumber, idInvoice, fileName}) {
    context.commit(DOWNLOAD_INVOICE_LOADING)
    return downloadInvoice({idShipment, orderNumber, idInvoice, fileName})
      .then((response) => {
        context.commit(DOWNLOAD_INVOICE_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_INVOICE_ERROR, error)
      })
  },

  [DOWNLOAD_PROOF] (context, payload) {
    context.commit(DOWNLOAD_PROOF_LOADING)
    return downloadProof(payload)
      .then((response) => {
        context.commit(DOWNLOAD_PROOF_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_PROOF_ERROR, error)
      })
  },

  [CREATE_PAYMENT] (context, data) {
    context.commit(CREATE_PAYMENT_LOADING)
    return createPayment(data)
      .then((response) => {
        context.commit(CREATE_PAYMENT_DONE, response)
        // this.$store.dispatch('payment/PAYMENT_PROCESS_TEMP', {data: response.data})
      })
      .catch((error) => {
        context.commit(CREATE_PAYMENT_ERROR, error)
      })
  },

  [FETCH_INVOICE_DETAIL] (context, {idInvoice, type}) {
    context.commit(FETCH_INVOICE_DETAIL_LOADING)
    return getInvoiceDetail(idInvoice, type)
      .then((response) => {
        context.commit(FETCH_INVOICE_DETAIL_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_INVOICE_DETAIL_ERROR, true)
        console.error(error)
      })
  },

  [PAYMENT_PROCESS_TEMP] (context, data) {
    context.commit(PAYMENT_PROCESS_TEMP, data)
    localStorage.setItem(PAYMENT_PAY_NOW, JSON.stringify(data))
  },

  [FETCH_PAYMENT_HISTORY] (context, id) {
    context.commit(FETCH_PAYMENT_HISTORY_LOADING)
    return getPaymentHistory(id)
      .then((response) => {
        context.commit(FETCH_PAYMENT_HISTORY_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PAYMENT_HISTORY_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_PAYMENT_DETAIL] (context, id) {
    context.commit(FETCH_PAYMENT_DETAIL_LOADING)
    return getPaymentDetail(id)
      .then((response) => {
        context.commit(FETCH_PAYMENT_DETAIL_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PAYMENT_DETAIL_ERROR, true)
        console.error(error)
      })
  },

  [PUT_PAYMENT_PARTIAL_PROOF] (context, form) {
    context.commit(PUT_PAYMENT_PARTIAL_PROOF_LOADING)
    return putProofPaymnet(form)
      .then((response) => {
        context.commit(PUT_PAYMENT_PARTIAL_PROOF_DONE, response)
      })
      .catch((error) => {
        context.commit(PUT_PAYMENT_PARTIAL_PROOF_ERROR, true)
        console.error(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/actions.js